import { locationSurchargeType } from "./location-surcharge-type.const";
import { LocationSurchargeBase } from "./location-surcharge-base.model";
import { LocationSurcharge } from "./location-surcharge.type";
import { LocationSurchargeMapper } from "./location-surcharge.mapper";
import { Carrier } from "../../carrier/carrier.model";
import { LclQuoteLocationSurcharge } from "../../quote/quote-surcharge/models/quote-location-surcharge-lcl.model";
import { SurchargeType } from "app/surcharge-type/surcharge-type.model";
import { SurchargeTypeMapper } from "app/surcharge-type/surcharge-type.mapper";

export class LtlLocationSurcharge extends LocationSurchargeBase {
  constructor(
    public id: number,
    public discriminator: string,
    public name: string = "",
    protected carrier: Carrier,
    protected type: string = locationSurchargeType.destination,
    protected shipmentPrice: number = 0,
    protected pricePer100Kg: number = 0,
    protected pricePerPiece: number = 0,
    protected pricePerPallet: number = 0,
    protected assignment: string = "",
    protected quoteLocationSurcharges: LclQuoteLocationSurcharge[],
    public currency: string = "USD",
    public surchargeType?: SurchargeType,
    public debugInfo?: string,
    public chargedFor?: string,
    public internalNote?: string,
    public sort?: number,
  ) {
    super(
      id,
      discriminator,
      name,
      carrier,
      type,
      assignment,
      quoteLocationSurcharges,
      currency,
      surchargeType,
      debugInfo,
      chargedFor,
      internalNote,
      sort,
    );
  }

  public getFirstQuoteLocationSurcharge(): LclQuoteLocationSurcharge {
    if (this.haveQuoteLocationSurcharges()) {
      return this.quoteLocationSurcharges[0];
    }
  }

  public getRequestParams() {
    return {
      shipmentPrice: this.shipmentPrice,
      pricePer100Kg: this.pricePer100Kg,
      pricePerPiece: this.pricePerPiece,
      pricePerPallet: this.pricePerPallet,
      carrier: this.getCarrier() ? this.getCarrier().getId() : null,
      name: this.getName(),
      type: this.getType(),
      sort: this.sort,
      surchargeType: this.getSurchargeType()
        ? this.getSurchargeType().getId()
        : null,
    };
  }

  public getClone(): LocationSurcharge {
    return LocationSurchargeMapper.map({
      id: this.id,
      discriminator: this.discriminator,
      name: this.name,
      carrier: this.carrier,
      type: this.type,
      shipmentPrice: this.shipmentPrice,
      pricePer100Kg: this.pricePer100Kg,
      pricePerPiece: this.pricePerPiece,
      pricePerPallet: this.pricePerPallet,
      assignment: this.assignment,
      quoteLocationSurcharges: this.quoteLocationSurcharges,
      currency: this.currency,
      sort: this.sort,
      chargedFor: this.chargedFor,
      surchargeType: SurchargeTypeMapper.map(this.getSurchargeType()),
    });
  }
}
